var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import CustomMarker from "./CustomMarker";
import "./map-control.css";
import { getSites } from "../../utils/api/sites/dataAccess";
import { getTrials } from '../../utils/api/trials/dataAccess';
const MapControl = () => {
    const position = { lat: -28.505, lng: 137.0 };
    const [siteInformation, setSiteInformation] = useState([]);
    useEffect(() => {
        const fetchTrials = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const sites = yield getSites();
                const trials = yield getTrials();
                console.log(sites.data, trials.data);
                if (sites.data && trials.data) {
                    // Filter the sites to ensure there are no null values for lat/long
                    const filteredSites = sites.data.filter(site => site.latitude !== null && site.longitude !== null);
                    const siteLabels = filteredSites.map(site => {
                        const siteTrials = trials.data.filter(trial => trial.siteName === site.name);
                        return {
                            id: site.id,
                            siteName: site.name,
                            regionName: siteTrials.length > 0 ? siteTrials[0].regionName : "",
                            latitude: site.latitude,
                            longitude: site.longitude,
                            numberOfTrials: siteTrials.length
                        };
                    });
                    // restrict to sites where the number of trials is greater than 0
                    setSiteInformation(siteLabels.filter(site => site.numberOfTrials > 0));
                }
            }
            catch (error) {
                console.error("Error fetching sites:", error);
            }
        });
        fetchTrials();
    }, []);
    return (React.createElement("div", { id: "map" },
        React.createElement(MapContainer, { id: "map-control", center: position, zoom: 5, scrollWheelZoom: false },
            React.createElement(TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
            siteInformation.map((site) => (React.createElement(CustomMarker, { key: site.id, Position: { lat: site.latitude, lng: site.longitude }, SiteName: site.siteName, RegionName: site.regionName, NumberOfTrials: site.numberOfTrials }))))));
};
export default MapControl;
